module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }